import React from 'react'
import ReactDOM from 'react-dom'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { msalConfig } from 'src/main/configs/msal'
import App from './presentation/components/app'

const msalInstance = new PublicClientApplication(msalConfig)

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

msalInstance.addEventCallback((event: any) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const { account } = event.payload
    msalInstance.setActiveAccount(account)
  }
})

ReactDOM.render(
  <React.StrictMode>
    <App instance={msalInstance} />
  </React.StrictMode>,
  document.getElementById('root'),
)
